// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tabs_wrapper__ZQmXt","tab":"tabs_tab__19qeu","activeTab":"tabs_activeTab__2rcq-"};